import { useState } from 'react'

// Свёрнуто ли левое меню на десктопе. Запоминается в браузере, чтобы после
// перезагрузки страницы меню осталось таким, каким его оставил сотрудник.
// По умолчанию меню развёрнуто.
export const SIDEBAR_COLLAPSED_KEY = 'crm_sidebar_collapsed_v1'

function readCollapsed(): boolean {
  try {
    return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === '1'
  } catch {
    return false
  }
}

export function useSidebarCollapsed(): [boolean, () => void] {
  const [collapsed, setCollapsed] = useState(readCollapsed)

  const toggle = () =>
    setCollapsed((prev) => {
      const next = !prev
      try {
        localStorage.setItem(SIDEBAR_COLLAPSED_KEY, next ? '1' : '0')
      } catch {
        /* localStorage недоступен — не критично */
      }
      return next
    })

  return [collapsed, toggle]
}
